import CardContainer from "@vfuk/core-container";
import Paragraph from "@vfuk/core-paragraph";
import SimpleGrid from "@vfuk/core-simple-grid";
import Button from "@vfuk/core-button";
import { ReactNode } from "react";
import Spacing from "@vfuk/core-spacing";
import Heading from "@vfuk/core-heading";
import { RolesTypes, BaseTypes } from "@hub/common-libs";
import { useNavigate } from "react-router-dom";

export interface CardBoxProps {
  id: string;
  title: string;
  rows?: RolesTypes.BackendPermissionMatrix;
  footer?: string;
  image: ReactNode;
  image1: ReactNode;
  actions: BaseTypes.Actions | null;
  userPermissions: {
    canAdd?: boolean;
    canEdit?: boolean;
    canView?: boolean;
    canDelete?: boolean;
  };
}

export const CardBox = (props: CardBoxProps): JSX.Element => {
  const navigate = useNavigate();

  const renderPermission = (rows: CardBoxProps["rows"]) => {
    if (!rows) return;

    const permissionType = Object.keys(rows);
    return permissionType.map((permissionType, i) => (
      <div key={i}>
        {rows[permissionType] && i < 2 && (
          <Spacing spacingLevel={{ bottom: 2 }}>
            <Paragraph weight={2}>
              {" "}
              {permissionType}
              <span style={{ float: "right" }}>{props.image1}</span>
            </Paragraph>
          </Spacing>
        )}
        {!rows[permissionType] && i < 2 && (
          <Spacing spacingLevel={{ bottom: 0 }}>
            <Paragraph weight={2}>
              {" "}
              {permissionType}{" "}
              <span style={{ float: "right" }}>{props.image}</span>
            </Paragraph>
          </Spacing>
        )}
        {rows[permissionType] && i > 1 && (
          <Paragraph weight={2} noMargin={true}>
            {" "}
            {permissionType}{" "}
            <span style={{ float: "right" }}>{props.image1}</span>
          </Paragraph>
        )}
        {!rows[permissionType] && i > 1 && (
          <Paragraph weight={2} noMargin={true}>
            {" "}
            {permissionType}{" "}
            <span style={{ float: "right" }}>{props.image}</span>
          </Paragraph>
        )}
      </div>
    ));
  };
  return (
    <>
      <div>
        <CardContainer>
          <div>
            <Heading size={1} text={props.title} weight={3} />
            <Spacing spacingLevel={{ top: 10 }}>
              {props.rows && (
                <>
                  <SimpleGrid
                    columns={{
                      sm: 1,
                      md: 2,
                    }}
                    spacing={5}
                    verticalAlign="center"
                    key={props.id}
                  >
                    {renderPermission(props.rows)}
                  </SimpleGrid>
                </>
              )}
            </Spacing>
            <div>
              <Spacing spacingLevel={{ top: 6 }}>
                {props.actions &&
                  (props.actions.view ? (
                    <Button
                      width="full"
                      onClick={() => navigate("/roles/" + props.id)}
                      text={props.actions.view.label}
                      appearance="alt1"
                      state={
                        props.userPermissions.canView ? undefined : "disabled"
                      }
                    />
                  ) : null)}
                {props.footer && (
                  <div style={{ color: "#666666" }}>
                    <Spacing spacingLevel={{ top: 6, left: 2, bottom: 2 }}>
                      <Paragraph weight={1}> {props.footer} </Paragraph>
                    </Spacing>
                  </div>
                )}
              </Spacing>
            </div>
          </div>
        </CardContainer>
      </div>
    </>
  );
};
